import { RESET_APP } from 'actions';

export function resetApp() {
  return { type: RESET_APP };
}
